// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1aIJH","content":"styles_content__3IIn9","selectAll":"styles_selectAll__2aKLe"};